module.exports = __webpack_public_path__ + "static/media/Group 1171276216.0fdc89d8.svg";